import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { RolesService } from '../../../../core/api/services/roles.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-role-users-form',
    templateUrl: './role-users-form.component.html',
    imports: [BaseFormModule]
})
export class RoleUsersFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formId: string = 'RoleUsersForm';

  @Input() roleId: number;
  @Input() organizationId: number;
  @Input() users: string[] = [];
  resultUsers: string[] = [];
  //#endregion

  constructor(protected currentService: RolesService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.title = 'pages.roles.userRoles.title';
      this.resultUsers = Object.assign([], this.users);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      users: new FormControl(''),
    });
  }

  //#region api

  baseCreateApi() {
    this.unSubs();

    this.loading = true;

    this.currentService
      .rolesAddOrUpdateRoleUsers({
        roleId: this.roleId,
        body: this.users,
        organizationId: this.organizationId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: any): void {
    this.baseCreateApi();
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.baseCreateApi();
  }

  onReset() {
    this.users = Object.assign([], this.resultUsers);
  }
}
